"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgsState = exports.isParam = void 0;
const __1 = require("../../..");
const isParam = (entry) => !entry.heading && !entry.sep && typeof entry.kind === 'string';
exports.isParam = isParam;
class ArgsState {
    constructor(props) {
        this.props = props;
        this.onSubmit = () => {
            if (!this.canSubmit())
                return;
            const list = [];
            const { props, args } = this;
            const map = args.value;
            for (const param of props.params ?? []) {
                if (!(0, exports.isParam)(param))
                    continue;
                const idOrName = param.id ?? param.name;
                list.push([idOrName, map[idOrName]]);
            }
            props.onSubmit?.(list, map);
        };
        const map = {};
        for (const param of props.params) {
            if (!(0, exports.isParam)(param))
                continue;
            if (param.kind === 'btn' || param.kind === 'code' || param.kind === 'info')
                continue;
            const id = String(param.id ?? param.name);
            if (param.defaultable) {
                const def = param.initialDef ?? true;
                const value = param.initialValue !== undefined ? param.initialValue : param.default;
                map[id] = { def, value };
            }
            else {
                map[id] = param.default;
            }
        }
        this.args = __1.rsync.val(map);
    }
    setValue(name, value) {
        const next = { ...this.args.value, [name]: value };
        this.args.next(next);
        const onChange = this.props.onChange;
        if (onChange) {
            const list = [];
            for (const param of this.props.params ?? []) {
                if (!(0, exports.isParam)(param))
                    continue;
                const idOrName = param.id ?? param.name;
                list.push([idOrName, next[idOrName]]);
            }
            onChange(list, next);
        }
    }
    canSubmit() {
        const args = this.args;
        const map = args.value;
        for (const param of this.props.params) {
            if (!(0, exports.isParam)(param))
                continue;
            if (param.kind === 'btn' || param.kind === 'code' || param.kind === 'info')
                continue;
            if (param.optional || param.defaultable)
                continue;
            const id = param.id ?? param.name;
            if (map[id] === undefined)
                return false;
        }
        return true;
    }
}
exports.ArgsState = ArgsState;
